<template>
  <div class="viewCallsEmployer">
    <!-- Main Body Content area -->
      <div class="o-main-content-area o-main-content-area--padBotoomNone">

          <!-- Heading Section -->
          <div class="row c-responsive-fixwidth">
              <div class="col-md-6">
                  <h1 class="h1">Jobs / Events:<a href="javascript: void(0)" @click="backToJobDetails()">{{" "+ title}}</a></h1>
              </div>
          </div>
          <!-- /Heading Section -->

          <!-- list head -->
         <!--  <div class="c-common-space c-responsive-fixwidth">
              <div class="col-md-12 o-tab-area o-no-padding">
                  <ul class="o-tab-view o-tab-view--text">
                      <li @click="goToViewCalls()"><a class="active">Calls</a></li>
                      <li @click="goToPhoneSheet()"><a >PhoneSheet</a></li>
                  </ul>
              </div>
          </div> -->
          <!-- /list head -->

          <!-- Days Filter -->
          <div class="c-common-space c-common-space--overflowVisible clearfix c-responsive-fixwidth">
              <div class="col-md-12 o-no-padding">
                  <div class="custom-row">
                      <div class="custom-col text-left">
                          <div class="o-viewBy">
                              <label>View by:</label>
                              <div class="radio">
                                  <label>
                                      <input type="radio" @change="saveStateEvent" name="o11" value="individual" v-model="callType">
                                      <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                      Individual calls
                                  </label>
                              </div>
                              <div class="radio">
                                  <label>
                                      <input type="radio" @change="saveStateEvent" name="o11" value="bulk" v-model="callType">
                                      <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                      Bulk calls
                                  </label>
                              </div>
                          </div>
                      </div>
                      <div class="custom-col outer--border text-center">
                          <div class="o-customSelect o-custom-dropdown o-inline-block">
                              <label>Jump to day:</label>
                              <select @change="onSelectScrollTo($event)" class="form-control">
                                  <!-- key.split(" ")[0] -->
                                  <option v-for="(call, key, index) in calls" :key="index" v-if="call.length>0" :value="'#element'+index" >{{getDateScrollTO(key)}}</option>
                              </select>
                              <span class="o-custom-drop-arrow"><i aria-hidden="true" class="fa fa-angle-down"></i></span>
                          </div>
                      </div>
                      <div class="custom-col text-center">
                          <div class="o-pub">
                              <label><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Pub</label>
                              <!-- {{selectedJobStatus}} -->
                              <el-switch
                                style="display: inline"
                                v-model="selectedJobStatus"
                                active-color="#13ce66"
                                inactive-color="#dcdfe6"
                                active-value="Published"
                                inactive-value="Draft" disabled>
                              </el-switch>
                              <!-- <div class="toggle-btn"><toggle-button /></div> -->
                          </div>
                      </div>
                      <div class="custom-col text-center">
                          <div class="o-customSelect o-custom-dropdown o-inline-block">
                              <label>Sort by:</label>
                              <select v-model="selectedSortType" class="form-control">
                                  <option value="start">Start time</option>
                                  <option value="skill">Skill</option>
                                  <option value="status">Unassigned</option>
                              </select>
                              <span class="o-custom-drop-arrow"><i aria-hidden="true" class="fa fa-angle-down"></i></span>
                          </div>
                      </div>
                      <div class="custom-col text-right">
                        <a  href="javascript: void(0)" @click="addBulkCall()" :class="job && job.client && job.client.employer && job.client.employer[0].status && job.client.employer[0].status.name !='View Access'?'c-solid-btn c-solid-btn--large c-solid-btn--green':'c-solid-btn c-solid-btn--large c-solid-btn--green disabled'"><i class="fa fa-plus" aria-hidden="true"></i> Add Calls</a>
                      </div>
                  </div>
              </div>
          </div>
          <!-- /Days Filter -->
      </div>

      <IndividualCalls :sortType="selectedSortType" :job="job" v-if="callType == 'individual' &&  !apiWait"/>
      <BulkCalls :sortType="selectedSortType" :job="job" v-if="callType == 'bulk' &&  !apiWait"/>

      <modal name="bulk-call"  height="auto" :clickToClose="false" :scrollable="true" class="modal-dialog modal-sm">
        <div class="employee-summary" tabindex="-1" role="dialog">
          <div  role="document">
            <!-- .modal-content -->
            <div class="modal-content o-common-modal-content">

              <!-- .modal-header -->
              <div class="modal-header u-no-border text-center modal-header--heading">
                <button @click="closeBulkModal()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">Add Calls</h4>
              </div>
              <!-- /.modal-header -->

              <!-- .modal-body -->
              <div class="modal-body c-common-box-shadow o-modal-body">
                <!--modal-Body-fixed -->
                <div class="bulk-filter">
                     <h2 class="h2 text-center o-modal-link">{{title}}</h2>
                     <div class="c-common-space o-subtitleHeading text-center">
                         <label>Group by: </label>
                         <span>
                             <div class="checkbox o-custom-radio">
                                 <label>
                                     Position
                                     <input type="checkbox" id="checkbox" @change="onInputchangeCheckbox" v-model="modalFilter.position">
                                     <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                 </label>
                             </div>
                         </span>
                         <span>
                             <div class="checkbox o-custom-radio">
                                 <label>
                                     Start time
                                     <input type="checkbox" id="checkbox" @change="onInputchangeCheckbox" v-model="modalFilter.startTime">
                                     <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                 </label>
                             </div>
                         </span>
                         <span>
                             <div class="checkbox o-custom-radio">
                                 <label>
                                     End time
                                     <input type="checkbox" id="checkbox" @change="onInputchangeCheckbox" v-model="modalFilter.endTime">
                                     <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                 </label>
                             </div>
                         </span>
                     </div>
                     <div class="row">
                         <div class="col-sm-12">
                             <hr class="o-modal-separetor">
                         </div>
                     </div>
                </div>
                <!--./modal-Body-fixed -->


                <!--.modal-Body-Start-End-Position -->
                <div v-if="modalFilter.position && modalFilter.startTime && modalFilter.endTime" class="add-bulk-form">
                     <div class="c-common-space">
                         <h2 class="h2">All created calls will have the following values:</h2>
                     </div>
                     <div class="row">
                         <div class="col-sm-4">
                             <div class="form-group">
                                <label class="common-label-text common-label-text-block">Start Date:</label>
                                <el-col :span="50">
                                  <el-date-picker
                                    name="date"
                                    class="custom_date"
                                    v-validate="{ required: true}"
                                    v-model="addCall[0].date"
                                    type="date"
                                    :picker-options="pickerOptions"
                                    :format="getDisplayFormat()"
                                    value-format="yyyy-MM-dd"
                                    :placeholder="getDatePlaceholder()">
                                  </el-date-picker>
                                </el-col>
                             </div>
                         </div>
                         <div class="col-sm-4">
                             <div class="form-group">
                                 <label class="common-label-text common-label-text-block">Start time:</label>
                                 <div class="o-custom-dropdown">
                                     <date-picker placeholder="HH:MM AM" name="start" v-validate="{required: true}" v-model="addCall[0].start" :config="config"></date-picker>
                                     <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                 </div>
                             </div>
                         </div>
                         <div class="col-sm-4">
                             <div class="form-group">
                                <label class="common-label-text common-label-text-block">End time</label>
                                <div class="o-custom-dropdown">
                                   <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCall[0].end" :config="config"></date-picker>
                                   <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                 </div>
                             </div>
                         </div>
                       </div>
                         <div class="row">
                         <div class="col-sm-4">
                             <div class="form-group">
                                 <label class="common-label-text common-label-text-block">Position:</label>
                                 <div class="o-cutsomSelect" v-loading="positionLock">
                                     <select v-model="addCall[0].position" class="form-control">
                                         <option v-for="(position,positionIndex) in positions" :key="positionIndex" :value="position.id">{{position.name}}</option>
                                     </select>
                                 </div>
                             </div>
                         </div>
                         
                     </div>
                     <div v-for="(addCallData, key) in addCall" :key="key" class="added-row">
                         <div v-if="key != 0" class="add-remove-row-btn text-center">
                             <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block"><i class="fa fa-minus-circle"></i></a>
                         </div>
                         <hr class="o-modal-separetor">
                         <div class="c-common-space">
                             <h2 class="h2">Call groups:</h2>
                         </div>
                         <div class="row">
                             <div class="col-sm-6">
                                 <div class="form-group">
                                     <label class="common-label-text common-label-text-block">Quantity:</label>
                                     <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                                 </div>
                             </div>
                             <div class="col-sm-6">
                                 <div class="form-group">
                                     <label class="common-label-text common-label-text-block">Rate:</label>
                                     <input type="text" v-model="addCallData.rate" name="rate" class="form-control" placeholder="">
                                 </div>
                             </div>
                             <div class="col-sm-12">
                                 <div class="form-group">
                                     <label class="common-label-text common-label-text-block">Notes:</label>
                                     <textarea v-model="addCallData.notes" class="form-control" rows="3" placeholder="Type your notes"></textarea>
                                 </div>
                             </div>
                             
                         </div>
                     </div>
                     <div class="add-remove-row-btn text-center">
                         <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block"><i class="fa fa-plus-circle"></i></a>
                     </div>
                </div>
                <!--./modal-body-Start-End-Position -->

                <!--.modal-Body-Start-End-->
                <div v-if="!modalFilter.position && modalFilter.startTime && modalFilter.endTime" class="add-bulk-form">
                  <div class="c-common-space">
                      <h2 class="h2">All created calls will have the following values:</h2>
                  </div>
                  <div class="row">
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">Start Date:</label>
                              <el-col :span="50">
                                <el-date-picker
                                  name="date"
                                  class="custom_date"
                                  v-validate="{ required: true}"
                                  v-model="addCall[0].date"
                                  type="date"
                                  :picker-options="pickerOptions"
                                  :format="getDisplayFormat()"
                                  value-format="yyyy-MM-dd"
                                  :placeholder="getDatePlaceholder()">
                                </el-date-picker>
                              </el-col>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">Start time</label>
                              <div class="o-custom-dropdown">
                                 <date-picker placeholder="HH:MM AM" name="start" v-validate="{required: true}" v-model="addCall[0].start" :config="config"></date-picker>
                                 <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">End time</label>
                              <div class="o-custom-dropdown">
                                 <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCall[0].end" :config="config"></date-picker>
                                 <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div v-for="(addCallData,key) in addCall" :key="key" class="added-row">
                    <div v-if="key != 0" class="add-remove-row-btn text-center">
                       <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block">
                        <i class="fa fa-minus-circle"></i>
                       </a>
                    </div>
                    <hr class="o-modal-separetor">
                    <div class="c-common-space">
                        <h2 class="h2">Call groups:</h2>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="common-label-text common-label-text-block">Position:</label>
                                <div class="o-cutsomSelect" v-loading="positionLock">
                                    <select v-model="addCallData.position" class="form-control">
                                      <option v-for="(position,positionIndex) in positions" :key="positionIndex" :value="position.id">{{position.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="common-label-text common-label-text-block">Quantity:</label>
                                <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                            </div>
                        </div>
                        <div class="col-sm-4">
                                 <div class="form-group">
                                     <label class="common-label-text common-label-text-block">Rate:</label>
                                     <input type="text" v-model="addCallData.rate" name="rate" class="form-control" placeholder="">
                                 </div>
                             </div>
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="common-label-text common-label-text-block">Notes:</label>
                                <textarea v-model="addCallData.notes" class="form-control" rows="3" placeholder="Type your notes"></textarea>
                            </div>
                        </div>
                    </div>
                  </div>
                    <div class="add-remove-row-btn text-center">
                       <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block">
                        <i class="fa fa-plus-circle"></i>
                       </a>
                    </div>
                </div>
                <!--./modal-body-Start-End -->

                <!--.modal-Body-Position-->
                <div v-if="modalFilter.position && !modalFilter.startTime && !  modalFilter.endTime" class="add-bulk-form">
                  <div class="c-common-space">
                      <h2 class="h2">All created calls will have the following values:</h2>
                  </div>
                  <div class="row">
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">Start Date:</label>
                              <el-col :span="50">
                                <el-date-picker
                                  name="date"
                                  class="custom_date"
                                  v-validate="{ required: true}"
                                  v-model="addCall[0].date"
                                  type="date"
                                  :picker-options="pickerOptions"
                                  :format="getDisplayFormat()"
                                  value-format="yyyy-MM-dd"
                                  :placeholder="getDatePlaceholder()">
                                </el-date-picker>
                              </el-col>
                          </div>
                      </div>

                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">Position:</label>
                              <div class="o-cutsomSelect" v-loading="positionLock">
                                  <select v-model="addCall[0].position" class="form-control">
                                    <option v-for="(position,positionIndex) in positions" :key="positionIndex" value="position.id">{{position.name}}</option>
                                  </select>
                              </div>
                          </div>
                      </div>

                  </div>
                  <div v-for="(addCallData,key) in addCall" :key="key" class="added-row">
                      <div v-if="key != 0" class="add-remove-row-btn text-center">
                         <a href="javascript: void(0)" @click="removeGroup" class="o-inline-block">
                             <i class="fa fa-minus-circle"></i>
                         </a>
                      </div>
                      <hr class="o-modal-separetor">
                      <div class="c-common-space">
                          <h2 class="h2">Call groups:</h2>
                      </div>
                      <div class="row">
                          
                          <div class="col-sm-6">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">Start Time:</label>
                                  <div class="o-custom-dropdown">
                                     <date-picker placeholder="HH:MM AM" name="start" v-validate="{required: true}" v-model="addCallData.start" :config="config"></date-picker>
                                     <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                  </div>
                              </div>
                          </div>
                          <div class="col-sm-6">
                                  <div class="form-group">
                                      <label class="common-label-text common-label-text-block">End Time:</label>
                                      <div class="o-custom-dropdown">
                                         <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCallData.end" :config="config"></date-picker>
                                         <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                      </div>
                                  </div>
                          </div>
                          <div class="col-sm-6">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">Quantity:</label>
                                  <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                              </div>
                          </div>
                          <div class="col-sm-6">
                                 <div class="form-group">
                                     <label class="common-label-text common-label-text-block">Rate:</label>
                                     <input type="text" v-model="addCallData.rate" name="rate" class="form-control" placeholder="">
                                 </div>
                             </div>
                          <div class="col-sm-12">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">Notes:</label>
                                  <textarea class="form-control" v-model="addCallData.notes" rows="3" placeholder="Type your notes"></textarea>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div @click="addNewGroup()" class="add-remove-row-btn text-center">
                     <a href="javascript: void(0)" class="o-inline-block">
                         <i class="fa fa-plus-circle"></i>
                     </a>
                  </div>
                </div>
                <!--./modal-body-Position -->

                <!--.modal-Body-Position-End-->
                <div v-if="modalFilter.position && !modalFilter.startTime &&   modalFilter.endTime" class="add-bulk-form">
                  <div class="c-common-space">
                      <h2 class="h2">All created calls will have the following values:</h2>
                  </div>
                  <div class="row">
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">Start Date:</label>
                              <el-col :span="50">
                                <el-date-picker
                                  name="date"
                                  class="custom_date"
                                  v-validate="{ required: true}"
                                  v-model="addCall[0].date"
                                  type="date"
                                  :picker-options="pickerOptions"
                                  :format="getDisplayFormat()"
                                  value-format="yyyy-MM-dd"
                                  :placeholder="getDatePlaceholder()">
                                </el-date-picker>
                              </el-col>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">Start Time:</label>
                              <div class="o-custom-dropdown">
                                 <date-picker placeholder="HH:MM AM" name="start" v-validate="{required: true}" v-model="addCall[0].start" :config="config"></date-picker>
                                 <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div v-for="(addCallData,key) in addCall" :key="key" class="added-row">
                      <div v-if="key != 0" class="add-remove-row-btn text-center">
                         <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block">
                             <i class="fa fa-minus-circle"></i>
                         </a>
                      </div>
                      <hr class="o-modal-separetor">
                      <div class="c-common-space">
                          <h2 class="h2">Call groups:</h2>
                      </div>
                      <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label class="common-label-text common-label-text-block">Position:</label>
                              <div class="o-cutsomSelect" v-loading="positionLock">
                                <select v-model="addCallData.position" class="form-control">
                                  <option v-for="(position,positionIndex) in positions" :key="positionIndex" :value="position.id">{{position.name}}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">End Time:</label>
                                  <div class="o-custom-dropdown">
                                     <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCallData.end" :config="config"></date-picker>
                                     <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                  </div>
                              </div>
                          </div>
                          <div class="col-sm-6">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">Quantity:</label>
                                  <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                              </div>
                          </div>
                          <div class="col-sm-6">
                                 <div class="form-group">
                                     <label class="common-label-text common-label-text-block">Rate:</label>
                                     <input type="text" v-model="addCallData.rate" name="rate" class="form-control" placeholder="">
                                 </div>
                             </div>
                          <div class="col-sm-12">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">Notes:</label>
                                  <textarea v-model="addCallData.notes" class="form-control" rows="3" placeholder="Type your notes"></textarea>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="add-remove-row-btn text-center">
                     <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block">
                         <i class="fa fa-plus-circle"></i>
                     </a>
                  </div>
                </div>
                <!--./modal-body-Position-End -->

                <!--.modal-Body-Position-Start-->
                <div v-if="modalFilter.position && modalFilter.startTime &&   !modalFilter.endTime" class="add-bulk-form">
                  <div class="c-common-space">
                      <h2 class="h2">All created calls will have the following values:</h2>
                  </div>
                  <div class="row">
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">Start Date</label>
                              <el-col :span="50">
                                <el-date-picker
                                  name="date"
                                  class="custom_date"
                                  v-validate="{ required: true}"
                                  v-model="addCall[0].date"
                                  type="date"
                                  :picker-options="pickerOptions"
                                  :format="getDisplayFormat()"
                                  value-format="yyyy-MM-dd"
                                  :placeholder="getDatePlaceholder()">
                                </el-date-picker>
                              </el-col>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">End Time:</label>
                              <div class="o-custom-dropdown">
                                 <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCall[0].end" :config="config"></date-picker>
                                 <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div v-for="(addCallData,key) in addCall" :key="key" class="added-row">
                      <div v-if="key != 0" class="add-remove-row-btn text-center">
                          <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block"><i class="fa fa-minus-circle"></i></a>
                      </div>
                      <hr class="o-modal-separetor">
                      <div class="c-common-space">
                          <h2 class="h2">Call groups:</h2>
                      </div>
                      
                      <div class="row">
                          <div class="col-sm-6">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">Start Time:</label>
                                  <div class="o-custom-dropdown">
                                     <date-picker placeholder="HH:MM AM" name="Start" v-validate="{required: true}" v-model="addCallData.Start" :config="config"></date-picker>
                                     <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                  </div>
                              </div>
                          </div>
                            <div class="col-sm-6">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">Position:</label>
                              <div class="o-cutsomSelect"  v-loading="positionLock">
                                <select v-model="addCallData.position" class="form-control">
                                  <option v-for="(position,positionIndex) in positions" :key="positionIndex" :value="position.id">{{position.name}}</option>
                                </select>
                              </div>
                          </div>
                      </div>
                          <div class="col-sm-6">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">Quantity:</label>
                                  
                                  <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                              </div>
                          </div>
                          <div class="col-sm-6">
                                 <div class="form-group">
                                     <label class="common-label-text common-label-text-block">Rate:</label>
                                     <input type="text" v-model="addCallData.rate" name="rate" class="form-control" placeholder="">
                                 </div>
                             </div>
                          <div class="col-sm-12">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">Notes:</label>
                                  <textarea v-model="addCallData.notes" class="form-control" rows="3" placeholder="Type your notes"></textarea>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="add-remove-row-btn text-center">
                      <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block"><i class="fa fa-plus-circle"></i></a>
                  </div>
                </div>
                <!--./modal-body-Position-Start -->

                <!--.modal-Body-Start-->
                <div v-if="!modalFilter.position && modalFilter.startTime &&   !modalFilter.endTime" class="add-bulk-form">
                  <div class="c-common-space">
                      <h2 class="h2">All created calls will have the following values:</h2>
                  </div>
                  <div class="row">
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">Start Date</label>
                                <el-date-picker
                                  name="date"
                                  class="custom_date"
                                  v-validate="{ required: true}"
                                  v-model="addCall[0].date"
                                  type="date"
                                  :picker-options="pickerOptions"
                                  :format="getDisplayFormat()"
                                  value-format="yyyy-MM-dd"
                                  :placeholder="getDatePlaceholder()">
                                </el-date-picker>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">End Time:</label>
                              <div class="o-custom-dropdown">
                                 <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCall[0].end" :config="config"></date-picker>
                                 <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">Position:</label>
                              <div class="o-cutsomSelect"  v-loading="positionLock">
                                  <select v-model="addCall[0].position" class="form-control">
                                    <option v-for="(position,positionIndex) in positions" :key="positionIndex" :value="position.id">{{position.name}}</option>
                                  </select>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div v-for="(addCallData,key) in addCall" :key="key" class="added-row">
                      <div v-if="key != 0" class="add-remove-row-btn text-center">
                          <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block"><i class="fa fa-minus-circle"></i></a>
                      </div>
                      <hr class="o-modal-separetor">
                      <div class="c-common-space">
                          <h2 class="h2">Call groups:</h2>
                      </div>
                      <div class="row">
                          <div class="col-sm-4">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">Quantity:</label>
                                 
                                  <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                              </div>
                          </div>
                          <div class="col-sm-4">
                             <div class="form-group">
                                 <label class="common-label-text common-label-text-block">Rate:</label>
                                 <input type="text" v-model="addCallData.rate" name="rate" class="form-control" placeholder="">
                             </div>
                          </div>
                          <div class="col-sm-4">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">Start Time:</label>
                                  <div class="o-custom-dropdown">
                                     <date-picker placeholder="HH:MM AM" name="Start" v-validate="{required: true}" v-model="addCallData.start" :config="config"></date-picker>
                                     <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                  </div>
                              </div>
                          </div>
                          <div class="col-sm-12">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">Notes:</label>
                                  <textarea v-model="addCallData.notes" class="form-control" rows="3" placeholder="Type your notes"></textarea>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="add-remove-row-btn text-center">
                      <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block"><i class="fa fa-plus-circle"></i></a>
                  </div>
                </div>
                <!--./modal-body-Start -->

                <!--.modal-Body-End-->
                <div v-if="!modalFilter.position && !modalFilter.startTime && modalFilter.endTime" class="add-bulk-form">
                  <div class="c-common-space">
                      <h2 class="h2">All created calls will have the following values:</h2>
                  </div>
                  <div class="row">
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">Start Date</label>
                                <el-date-picker
                                  name="date"
                                  class="custom_date"
                                  v-validate="{ required: true}"
                                  v-model="addCall[0].date"
                                  type="date"
                                  :picker-options="pickerOptions"
                                  :format="getDisplayFormat()"
                                  value-format="yyyy-MM-dd"
                                  :placeholder="getDatePlaceholder()">
                                </el-date-picker>

                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">Start Time:</label>
                              <div class="o-custom-dropdown">
                                 <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCall[0].start" :config="config"></date-picker>
                                 <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="form-group">
                              <label class="common-label-text common-label-text-block">Position:</label>
                              <div class="o-cutsomSelect"  v-loading="positionLock">
                                  <select v-model="addCall[0].position" class="form-control">
                                    <option v-for="(position,positionIndex) in positions" :key="positionIndex" :value="position.id">{{position.name}}</option>
                                  </select>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div v-for="(addCallData,key) in addCall" :key="key" class="added-row">
                      <div v-if="key != 0" class="add-remove-row-btn text-center">
                          <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block"><i class="fa fa-minus-circle"></i></a>
                      </div>
                      <hr class="o-modal-separetor">
                      <div class="c-common-space">
                          <h2 class="h2">Call groups:</h2>
                      </div>
                      <div class="row">
                          
                          <div class="col-sm-4">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">Quantity:</label>
                                  
                                  <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                              </div>
                          </div>
                          <div class="col-sm-4">
                             <div class="form-group">
                                 <label class="common-label-text common-label-text-block">Rate:</label>
                                 <input type="text" v-model="addCallData.rate" name="rate" class="form-control" placeholder="">
                             </div>
                          </div>

                          <div class="col-sm-4">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">End Time:</label>
                                  <div class="o-custom-dropdown">
                                     <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCallData.end" :config="config"></date-picker>
                                     <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                  </div>
                              </div>
                          </div>
                          <div class="col-sm-12">
                              <div class="form-group">
                                  <label class="common-label-text common-label-text-block">Notes:</label>
                                  <textarea v-model="addCallData.notes" class="form-control" rows="" placeholder="Type your notes"></textarea>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="add-remove-row-btn text-center">
                      <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block"><i class="fa fa-plus-circle"></i></a>
                  </div>
                </div>
                <!--./modal-body-End -->


              </div>
              <!-- /.modal-body -->

              <!-- .modal-footer -->
              <div class="modal-footer text-center">
                 <ul class="o-filter-area">
                     <li>
                         <a href="javascript: void(0)" @click="closeBulkModal()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                     </li>
                     <li>
                         <a href="javascript: void(0)" @click="saveBulkCall()" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Calls</a>
                     </li>
                 </ul>
              </div>
              <!-- /.modal-footer -->

            </div>
            <!-- /.modal-content -->
          </div>
        </div>
      </modal>
  </div>
</template>
<script>
    import IndividualCalls from './individualCalls';
    import BulkCalls from './bulkCalls';
    import dateTimeConvert from '../../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        bus
    } from '../../../main';
    import service from '../../../services.js';
    import {
        scroller
    } from 'vue-scrollto/src/scrollTo';

    export default {
        components: {
            'IndividualCalls': IndividualCalls,
            'BulkCalls': BulkCalls,
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                companyId: 'companyId',

                getSelectedCallList: 'getSelectedCallList',
                getLastPositionId: 'getLastPositionId',
            })
        },
        data() {
            const dataProps = {
                userClientID:'',
                apiWait:false,
                positionLock:false,
                jobStart: null,
                jobEnd: null,
                jobEmployeeId:'',//job steward employee id.
                job:{},
                selectedJobStatus: '',
                selectedSortType: 'skill',
                title: "",
                calls: [],
                config: {
                    format: 'h:mm A',
                    useCurrent: false,
                    showClear: false,
                    showClose: false,
                    widgetPositioning: {
                        //vertical: 'top',
                        horizontal: 'right'
                    },
                    parseInputDate: (inputDate) => {
                        if (typeof inputDate === 'string') {
                        // Handle case where user inputs 3 or 4 digits (e.g., 800 or 1230)
                        const match = inputDate.match(/^(\d{1,2})(\d{2})?$/);

                        if (match) {
                            let hours = parseInt(match[1], 10);
                            let minutes = match[2] ? parseInt(match[2], 10) : 0;

                            // Adjust hours if necessary for AM/PM logic (optional)
                            // if (hours > 12) hours -= 12;

                            // Return a Moment.js object
                            return moment({ hour: hours, minute: minutes });
                        }
                        }

                        // Default fallback to create a Moment object
                        return moment(inputDate, 'hh:mm A');
                    }
                },
                addCall: [{
                    date: '',
                    start: '',
                    end: '',
                    quantity: '',
                    rate: '',
                    position: '',
                    notes: ''
                }],
                modalFilter: {
                    position: false,
                    startTime: true,
                    endTime: true
                },
                callType: "individual",
                validation_err: 0,
                positions: [],
                pickerOptions: {
                    disabledDate(time) {
                        return (time.getTime() < dataProps.getDates().jobStart || time.getTime() > dataProps.getDates().jobEnd);
                    }
                },
                getDates: function() {
                    return {
                        jobStart: dataProps.jobStart,
                        jobEnd: dataProps.jobEnd
                    };
                }
            }

            return dataProps;
        },
        methods: {
            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                // console.log(format);
                return format?format:'MM/dd/yyyy';
            },
            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },
            getDate(str) {
                return dateTimeConvert.localDate(str);
            },
            getDateScrollTO(str) {
                return moment(str, 'YYYY-MM-DD').format('DD MMM YYYY');
            },
            backToJobDetails(){
                this.$router.push({
                    path: `/employerJobDetails/`+this.$route.params.jobId
                });
            },
            saveStateEvent() {
                this.$store.dispatch('setSelectedCallList', this.callType);
            },
            onSelectScrollTo(e) {
                const firstScrollTo = scroller();
                firstScrollTo(e.target.value, 200, {
                    offset: -100
                });
            },
            saveBulkCall() {
                //var addCallAuth=true;
                let callData = this.addCall.map(call => {
                    let data = {
                        "end": call.date + " " + dateTimeConvert.convertTo24Hours(call.end),
                        "job_id": this.job.id,
                        // "job_id": this.jobSkillId,
                        "quantity": call.quantity,
                        "rate": call.rate,
                        "skill_id": call.position,
                        "start": call.date + " " + dateTimeConvert.convertTo24Hours(call.start),
                        "called_at": call.date + " " + dateTimeConvert.convertTo24Hours(call.start),
                        "notes": call.notes
                    };
                    //if(dateTimeConvert.compareTime(call.start, call.end, 12)){
                      //addCallAuth=false;
                    if (moment(call.start, 'HH:mm A').format('HH:mm:ss')>=moment(call.end, 'HH:mm A').format('HH:mm:ss')) {
                      data.end=moment(data.end, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').format('YYYY-MM-DD HH:mm:ss');
                      //console.log("date Incrised",data.end);
                    }
                    return data;
                });

                //console.log(this.addCall[0].date);
                // console.log(callData);
                //addCallAuth=false;
                callData = JSON.stringify(callData);
                //console.log("Notes",callData);
                service.post('call/storeBulkCall', {
                        'call_array': callData
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((res) => {
                        this.$modal.hide("add-call");
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Call Added Successfully.',
                            type: 'success'
                        });
                        bus.$emit('onSaveNewCall', 'new Call Added');
                        this.$modal.hide("bulk-call");
                    }).catch((err) => {
                        console.log(err);
                    });
                //console.log(callData);
            },
            addBulkCall() {
                // this.$modal.show("bulk-call");
                // this.addCall = [{
                //     date: '',
                //     start: '',
                //     end: '',
                //     quantity: '',
                //     rate: '',
                //     position: '',
                //     notes: ''
                // }];
                // let getStartDate = this.job.start.split(" ");
                // //console.log(getStartDate[0])
                // this.addCall[0].date = getStartDate[0];
                // //console.log(this.job.start);
                // this.getSkill();
                this.$router.push({
					path:'/addCall/'+ this.$route.params.jobId
				});
            },
            closeBulkModal() {
                this.$modal.hide("bulk-call");
            },
            addNewGroup() {
                var temp = {
                    date: this.addCall[0].date,
                    start: this.addCall[0].start,
                    end: this.addCall[0].end,
                    quantity: '',
                    rate: this.addCall[0].rate,
                    position: this.addCall[0].position,
                    notes: ''
                };
                this.addCall.push(temp);
            },
            removeGroup(key) {
                this.addCall.splice(key, 1);
            },
            onInputchangeCheckbox() {
                this.addCall = [{
                    date: '',
                    start: '',
                    end: '',
                    quantity: '',
                    rate: '',
                    position: '',
                    notes: ''
                }];

                let getStartDate = this.job.start.split(" ");
                //console.log(getStartDate[0])
                this.addCall[0].date = getStartDate[0];
            },
            getSkill() {
                this.positionLock=true;
                service.get('skill/getAllSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    this.positions = res.data.result;
                    this.positionLock=false;
                }).catch((err) => {
                    console.log(err);
                    this.positionLock=false;
                });

            },
            jobDetails() {
                this.$Progress.start();
                this.apiWait=true;
                service.get('employerjob/' + atob(this.$route.params.jobId), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'employer-id': this.companyId
                }).
                then((res) => {
                    //console.log("Job details", res);
                    this.userClientID=res.data.result.client_id;
                    // console.log("Job details",this.userClientID);
                    this.title = res.data.result.title;
                    this.job=res.data.result;
                    this.jobStart = new Date(this.job.start);
                    this.jobStart.setDate(this.jobStart.getDate() - 1);
                    this.jobEnd = new Date(this.job.end);
                    this.jobEmployeeId=this.job.employee.id;
                    this.selectedJobStatus = (this.job.status)?this.job.status.name:'Draft';
                    this.apiWait=false;
                    this.$Progress.finish();
                }).catch((err) => {
                    this.apiWait=false;
                    console.log(err);
                });
            },
        },
        created() {
            this.callType = (this.getSelectedCallList) ? this.getSelectedCallList : "individual";
            this.jobDetails();
            //console.log("STATUS", this.getSelectedCallList);
            this.jobStart = new Date(this.job.start);
            this.jobStart.setDate(this.jobStart.getDate() - 1);
            this.jobEnd = new Date(this.job.end);
            document.title = `${this.job.job_number}#${this.job.title}`;
            //console.log(this.job.status.name);
            bus.$on('onUpdateCallList', (data) => {
                this.calls = data;
            });
            bus.$on('sortTypeChanged', (sort_type) => {
                this.selectedSortType = sort_type;
            })
        },
        mounted() {
            $(this.$el).find('input').datetimepicker(this.config)
            .on('dp.show', (e) => {
                const picker = e.target; // Reference to the picker element
                const currentTime = moment();

                // Check if the input is empty and set the current time in the picker
                if (!picker.value) {
                    $(picker).data('DateTimePicker').date(currentTime);
                }
            });
        }
    }

</script>
<style scoped>
    a:hover {
        cursor: pointer;
    }

    .v--modal-overlay.scrollable {
        margin-top: 0;
        padding-top: 30px;
    }

</style>
